export default __webpack_public_path__ + "static/media/resteo.5a548570.png";